export const url = 'https://mabuapi.newscloud.sbs.co.kr/api/cams'